var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_29215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71939 8.12256L8.46311 9.38309C7.95366 9.89432 7.0573 9.90533 6.53684 9.38309L5.2805 8.12256L0.768311 12.6494C0.93627 12.7271 1.12146 12.7734 1.31833 12.7734H13.6816C13.8785 12.7734 14.0636 12.7271 14.2315 12.6494L9.71939 8.12256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6817 2.22656H1.31839C1.12152 2.22656 0.936333 2.27291 0.768433 2.35058L5.59002 7.18816C5.59035 7.18849 5.59073 7.18854 5.59105 7.18887C5.59137 7.18919 5.59143 7.18963 5.59143 7.18963L7.15919 8.76258C7.32572 8.9291 7.67441 8.9291 7.84093 8.76258L9.40837 7.18989C9.40837 7.18989 9.40875 7.18919 9.40908 7.18887C9.40908 7.18887 9.40978 7.18849 9.4101 7.18816L14.2316 2.35055C14.0637 2.27285 13.8785 2.22656 13.6817 2.22656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140215 2.96533C0.0533203 3.14105 0 3.33611 0 3.54506V11.4552C0 11.6642 0.0532617 11.8592 0.140186 12.0349L4.66019 7.50028L0.140215 2.96533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8598 2.96533L10.3398 7.50034L14.8598 12.0351C14.9467 11.8593 15 11.6643 15 11.4553V3.54512C15 3.33611 14.9467 3.14105 14.8598 2.96533Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_29215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.2fe5812e33b02e078d73a311390455d3.svg";
export { ForwardRef as ReactComponent };